import React from "react";
import { getMultiLoadFuelValues } from "../constants";
import ConditionalRender from "../../../../../../../reusable-components/ConditionalRender";
import styles from "../BidToolForm.module.scss";
import clsx from "clsx";
import { formatNumber } from "../../../../../../../utils/numberFormatterUtil";
interface PercentageListProps {
  start: number;
  oneWayMiles: number;
  oneWayTime: number;
  loadsPerDayTruck: number;
  deadheadForwardMiles: number;
  deadheadBackwardMiles: number;
  truckMpgAvg: number;
  texasDieselAvg: number;
  initialPercentage: number;
  minBidValue?: number;
}
const gradientColors = [
  "#63BE7B",
  "#79C47C",
  "#90CA7D",
  "#A5D17E",
  "#BCD780",
  "#D2DE80",
  "#E8E482",
  "#FFEB84",
  "#FFD981",
  "#FEC67E",
  "#FCB47A",
  "#FBA176",
  "#FB8F73",
  "#F97C6F",
  "#F8696B",
];

const PercentageList = ({
  start,
  oneWayMiles,
  oneWayTime,
  loadsPerDayTruck,
  deadheadBackwardMiles,
  deadheadForwardMiles,
  truckMpgAvg,
  texasDieselAvg,
  initialPercentage,
  minBidValue,
}: PercentageListProps) => {
  const values = Array.from(
    { length: gradientColors.length },
    (_, i) => start + i + 1
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.8rem",
      }}
    >
      {values.map((value, index) => {
        const multiLoadFuelValue = getMultiLoadFuelValues({
          oneWayTime: oneWayTime,
          oneWayMiles: oneWayMiles,
          loadsPerDayTruck: loadsPerDayTruck,
          deadheadBackwardMiles: deadheadBackwardMiles,
          deadheadForwardMiles: deadheadForwardMiles,
          texasDieselAvg: texasDieselAvg,
          truckMpgAvg: truckMpgAvg,
          truckRate: 4,
          percentage: value,
        });
        const multiFuelValueClass = clsx({
          [styles.Green]: minBidValue?.toFixed(2) < multiLoadFuelValue,
          [styles.Red]: minBidValue?.toFixed(2) > multiLoadFuelValue,
        });
        return (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              width: "100%",
              // justifyContent: "space-between",
            }}
          >
            <div
              key={value}
              style={{
                backgroundColor: gradientColors[index],
                marginLeft: "1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "28px",
                width: "69px",
                borderRadius: "4px",
                textAlign: "center",
                fontWeight: "500",
                color: "#000",
              }}
            >
              <ConditionalRender visible={!isNaN(value)} fallback={"-"}>
                {value}%
              </ConditionalRender>
            </div>
            <div>
              <ConditionalRender
                visible={!isNaN(multiLoadFuelValue)}
                fallback={"-"}
              >
                <div className={multiFuelValueClass}>
                  <ConditionalRender
                    visible={multiLoadFuelValue !== Infinity}
                    fallback={<div className={styles.fallbackPercent}>-</div>}
                  >
                    ${formatNumber(Number(multiLoadFuelValue).toFixed(2))}
                  </ConditionalRender>
                </div>
              </ConditionalRender>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PercentageList;
